import SignType from "../../domain/signType";

const TOKEN_BY_TYPE = {
  [SignType.types.SIGN_ANYTIME]: "--sign-type-anytime",
  [SignType.types.PRESIGNED]: "--sign-type-presigned",
  [SignType.types.PRESIGNED_WITH_VIDEO]: "--sign-type-presigned-video",
  [SignType.types.DIGITAL_SIGNATURE]: "--sign-type-digital",
  [SignType.types.SIGNED_OFF_CAMERA]: "--sign-type-off-camera",
  [SignType.types.NO_AUTOGRAPH]: "--sign-type-no-autograph",
  [SignType.types.SHOUTOUT]: "--sign-type-shoutout",
  [SignType.types.AUDIO_SHOUTOUT]: "--sign-type-audio-shoutout",
  [SignType.types.IN_PERSON_SIGNING]: "--sign-type-in-person",
};

const signTypeColor = (signedType) =>
  TOKEN_BY_TYPE[signedType] ? `var(${TOKEN_BY_TYPE[signedType]})` : undefined;

export default signTypeColor;
